import { render } from "./App.vue?vue&type=template&id=aef17e38&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=aef17e38&lang=scss&scoped=true"

import exportComponent from "D:\\project\\console\\big_screen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef17e38"]])

export default __exports__